/**
 * OperationalBundleLoader
 *
 * Loading indicator while parsing or verifying bundle.
 */

import React from 'react';
import { NEUTRAL, TYPOGRAPHY } from '../modules/governanceEventStream/operationalVisualLanguage/index.js';

interface OperationalBundleLoaderProps {
  message?: string;
}

export const OperationalBundleLoader: React.FC<OperationalBundleLoaderProps> = ({
  message = 'Processing operational bundle…',
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      padding: 48,
      color: NEUTRAL.text400,
    }}>
      <div style={{
        width: 32,
        height: 32,
        border: `3px solid ${NEUTRAL.border}`,
        borderTopColor: NEUTRAL.text500,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }} />
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div style={{ fontSize: TYPOGRAPHY.body.size }}>
        {message}
      </div>
    </div>
  );
};
